import { StepperWeb } from "./web";
import { StepperBlockProps } from "./types";

export function StepperWebEditor(props: StepperBlockProps) {
  return <StepperWeb {...props} />;
}
